export default __webpack_public_path__ + "static/media/banking.ff40df1a.webp";